<div *ngIf="form" class="edit-product-container">
  <div class="form-container" [formGroup]="getFormGroup()">
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>EAN 1</mat-label>
        <input type="text" matInput formControlName="ean1" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>EAN 2</mat-label>
        <input type="text" matInput formControlName="ean2" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>EAN 3</mat-label>
        <input type="text" matInput formControlName="ean3" />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Produto</mat-label>
        <input type="text" matInput formControlName="productName" />
      </mat-form-field>
      <mat-form-field style="width: 300px">
        <mat-label>Apresentação</mat-label>
        <input type="text" matInput formControlName="presentation" />
      </mat-form-field>
      <mat-form-field style="width: 300px">
        <mat-label>Substância</mat-label>
        <input type="text" matInput formControlName="substance" />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field style="width: 400px">
        <mat-label>Laboratório</mat-label>
        <input type="text" matInput formControlName="laboratory" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>CNPJ</mat-label>
        <input type="text" matInput formControlName="fiscalNumber" appMask="fiscalNumberMask" />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Tipo do Produto</mat-label>
        <mat-select formControlName="productType" (selectionChange)="onProductTypeChange($event)">
          <mat-option *ngFor="let productType of getProductTypes()" [value]="productType">{{ productType.getValue() }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 250px">
        <mat-label>Sub Tipo do Produto</mat-label>
        <mat-select formControlName="productSubType">
          <mat-option *ngFor="let productSubType of getProductSubTypes()" [value]="productSubType">{{ productSubType.getValue() }}</mat-option>
        </mat-select>
      </mat-form-field>
      <auto-complete-search
        style="margin-right: 20px"
        [width]="300"
        [searchProvider]="therapeuticClassProvider"
        [placeholder]="'Classe Terapêutica'"
        [value]="getFormGroup().value.therapeuticClass?.getDescription()"
        (valueChange)="getAutoCompleteValue($event)"></auto-complete-search>
    </div>
    <div class="row">
      <mat-form-field style="width: 200px">
        <mat-label>Tipo de Validade</mat-label>
        <mat-select formControlName="productUseValidity">
          <mat-option *ngFor="let validity of getProductUseValidities()" [value]="validity">{{ validity.getUseType() }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 200px">
        <mat-label>Regime de Preço</mat-label>
        <mat-select formControlName="priceRegime">
          <mat-option *ngFor="let regime of getPriceRegimes()" [value]="regime">{{ regime.getValue() }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 200px">
        <mat-label>Tipo de Uso</mat-label>
        <mat-select formControlName="useType">
          <mat-option *ngFor="let type of getUseTypes()" [value]="type">{{ type.getValue() }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 250px">
        <mat-label>Concessão de Crédito Tributário</mat-label>
        <mat-select formControlName="tributaryCreditConcession">
          <mat-option *ngFor="let concession of getTributaryCreditConcessions()" [value]="concession">{{ concession.getValue() }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>GGREM</mat-label>
        <input type="text" matInput formControlName="GGREMCode" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Registro</mat-label>
        <input type="text" matInput formControlName="registry" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Sobre análise</mat-label>
        <input type="text" matInput formControlName="appealAnalysis" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Tarja</mat-label>
        <input type="text" matInput formControlName="targe" />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-checkbox formControlName="cap">CAP</mat-checkbox>
      <mat-checkbox formControlName="confaz">CONFAZ</mat-checkbox>
      <mat-checkbox formControlName="icms0Percent">0% de ICMS</mat-checkbox>
      <mat-checkbox formControlName="hospitalRestriction">Restrição Hospitalar</mat-checkbox>
      <mat-checkbox formControlName="commercialization">Comercialização</mat-checkbox>
    </div>
  </div>
  <div class="btn-conatiner">
    <button mat-flat-button class="back-btn" (click)="goToSearchProduct()">VOLTAR</button>
    <button mat-flat-button class="save-btn" (click)="createProduct()">SALVAR PRODUTO</button>
  </div>
</div>
